import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react'; // Ensure lucide-react is installed

const featuresData = [
  {
    id: 1,
    title: "Tell Us Your Requirements",
    description: "Shift from manual, repetitive tasks to AI-driven autonomy. We help build resilient systems that adapt to market changes instantly.",
    image: "/assets/career/img10.png",
  },
  {
    id: 2,
    title: "We Curate the Best Talent",
    description: "Leverage advanced analytics and machine learning models to process vast amounts of data, turning noise into actionable business insights.",
    image: "/assets/career/img10.png",
  },
  {
    id: 3,
    title: "Start Developing Faster",
    description: "Personalize every touchpoint with AI-powered recommendations and chatbots that understand intent, ensuring a seamless customer journey.",
    image: "/assets/career/img10.png",
  },
  {
    id: 4,
    title: "Ongoing Support",
    description: "From strategy to execution, we ensure that automation is not just a tool but a value driver that optimizes costs and maximizes efficiency.",
    image: "/assets/career/img10.png",
  },
];

const OurProcess = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="w-full bg-white pb-16 lg:pb-24">
      <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
        <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-6 lg:mb-20 text-left">
          Our Process
        </h2>
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24">
          <div className="lg:w-1/2 flex flex-col">
            {featuresData.map((item, index) => (
              <div
                key={item.id}
                onClick={() => setActiveIndex(index)}
                className={`group cursor-pointer flex items-center justify-between py-6 lg:py-8 border-b-[3px] transition-all duration-300
                  ${index === activeIndex
                    ? 'border-[#ED6800]'
                    : 'border-gray-300 hover:border-gray-600'
                  }
                `}
              >
                <h3
                  className={`text-[16px] md:text-[20px] font-[600] font-sora transition-colors duration-300
                    ${index === activeIndex ? 'text-[#01386A]' : 'text-[#0000008C] group-hover:text-gray-600'}
                  `}
                >
                  {item.title}
                </h3>
                <ChevronRight
                  size={24}
                  className={`transition-all duration-300 transform
                    ${index === activeIndex
                      ? 'opacity-100 translate-x-0 text-[#ED6800]'
                      : 'opacity-0 -translate-x-4 text-gray-300'
                    }
                  `}
                />
              </div>
            ))}
          </div>
          <div className="lg:w-1/2 flex flex-col justify-start">
            <div className="min-h-[100px] mb-8">
              <p
                key={activeIndex}
                className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-graphik font-[500] animate-fade-in"
              >
                {featuresData[activeIndex].description}
              </p>
            </div>
            <div className="w-full h-[300px] lg:h-[378px] overflow-hidden relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-100/50 to-transparent"></div>
              <img
                key={activeIndex}
                src={featuresData[activeIndex].image}
                alt={featuresData[activeIndex].title}
                className="w-full h-full object-cover mix-blend-multiply transition-opacity duration-500 opacity-0 animate-[fadeIn_0.5s_ease-in-out_forwards]"
              />
            </div>

          </div>

        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeIn 0.5s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default OurProcess;